import _ from 'lodash';

/**
 * Clean object by:
 * - Removing null values
 * - Removing empty arrays
 * - Removing anything inside [] from string values inside arrays
 *
 * @param {Record<string, any>} obj
 * @return {Record<string, any>}
 */
export const cleanObject = (obj: Record<string, any>): Record<string, any> => {
    const result: Record<string, any> = {};

    for (const [key, value] of Object.entries(obj)) {
        if (value === null) continue;

        if (Array.isArray(value)) {
            const cleanedArray = value
                .map((item) =>
                    typeof item === 'string'
                        ? item.replace(/\[.*?\]/g, '')
                        : item
                )
                .filter((item) => item !== null && item !== '');

            if (cleanedArray.length > 0) {
                result[key] = _.uniq(cleanedArray);
            }

            continue;
        }

        result[key] = value;
    }

    return result;
};
